import { createFileRoute } from '@tanstack/react-router';
import { ChangelogPage } from '@pages/changelog';

/** Route für die öffentliche Changelog-Seite (/changelog). */
export const Route = createFileRoute('/changelog')({ component: ChangelogPage });
